import { Loader2 } from 'lucide-react';

import UpdatesAvailable from '@/assets/ico/icon_updates-available.svg?c';
import UpToDate from '@/assets/ico/icon_up-to-date.svg?c';
import UpdatesUnknown from '@/assets/ico/icon_updates-unknown.svg?c';
import { Environment } from '@/react/portainer/environments/types';
import { isD2KEnvironment } from '@/react/portainer/environments/utils';

import { Status } from './types';

/**
 * isImageStatusEnabled tells whether image up-to-date indicators are shown.
 * d2k stores no images, so there is nothing to compare with the registry.
 */
export function isImageStatusEnabled(
  environment?: Pick<Environment, 'EnableImageNotification' | 'ContainerEngine'>
) {
  return (
    !!environment?.EnableImageNotification && !isD2KEnvironment(environment)
  );
}

export function geStatusIcon(status?: Status) {
  switch (status) {
    case 'outdated':
      return UpdatesAvailable;
    case 'updated':
      return UpToDate;
    case 'processing':
      return Loader2;
    case 'error': // may want a different icon for this in future, along with an error message
    case 'skipped':
    case undefined:
    case 'preparing':
    default:
      return UpdatesUnknown;
  }
}
